function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 7.5C3.675 7.5 3 6.825 3 6V2.25H0.75C0.3375 2.25 0 2.5875 0 3V9C0 9.4125 0.3375 9.75 0.75 9.75V11.25C0.75 11.6625 1.0875 12 1.5 12C1.71 12 1.8975 11.9175 2.0325 11.7825L4.0575 9.75H7.5C7.9125 9.75 8.25 9.4125 8.25 9V8.1225L7.6275 7.5H4.5ZM11.25 0H4.5C4.0875 0 3.75 0.3375 3.75 0.75V6C3.75 6.4125 4.0875 6.75 4.5 6.75H7.9425L9.975 8.7825C10.1025 8.9175 10.29 9 10.5 9C10.9125 9 11.25 8.6625 11.25 8.25V6.75C11.6625 6.75 12 6.4125 12 6V0.75C12 0.3375 11.6625 0 11.25 0Z",
  fill: "#5A57FF"
});

function SvgIconChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.d7930a5559954eb70f049c4830d86d05.svg";
export { ForwardRef as ReactComponent };